import React, {
  useEffect,
} from 'react';
import clsx from 'clsx';
import {
  PatientCompact,
} from 'pages/Dashboard/pages/Encounters/types/patient';
import {
  useLocation,
} from 'react-router-dom';
import Name from 'pages/Dashboard/components/Name';
import {
  getPatientChartPath,
} from 'pages/Dashboard/pages/Charts/utils';

type Props = {
  patient: PatientCompact | null;
  onNavigateAway: () => void;
  currentPath?: RegExp;
  className?: string;
};

export default function PatientName({
  patient,
  onNavigateAway,
  currentPath = /billing|appointments/i,
  className,
}: Props) {
  const location = useLocation();
  const inCharts = currentPath.test('charts');

  useEffect(() => {
    if (!inCharts && !currentPath.test(location.pathname)) {
      onNavigateAway?.();
    }
  }, [location.pathname]);

  return (
    <Name
      {...patient?.formattedNames}
      link={inCharts ? undefined : getPatientChartPath(patient?.patientId)}
      classes={{
        root: clsx('!w-fit mr-1 !font-semibold', className),
        icon: '!block',
      }}
    />
  );
}
